import { render } from "./AccountDestroy.vue?vue&type=template&id=06677b35&scoped=true"
import script from "./AccountDestroy.vue?vue&type=script&lang=js"
export * from "./AccountDestroy.vue?vue&type=script&lang=js"

import "./AccountDestroy.vue?vue&type=style&index=0&id=06677b35&lang=less&scoped=true"

import exportComponent from "F:\\handzone_game\\10001-sdk\\web\\hzgamebox\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06677b35"]])

export default __exports__